import { REMOVE_SHOW_ID } from '../../Dashboard/Referrals/reducer';
import { HIDE_TOOLTIP } from '../../reducer';

export const SHOW_TOOLTIP = 'ReferredPartnersShow/SHOW_TOOLTIP';
export const LOAD_SHOW = 'ReferredPartnersShow/LOAD_SHOW';
export const SET_SHOW_DATA = 'ReferredPartnersShow/SET_SHOW_DATA';
export const UPDATE_SHOW_DATA = 'ReferredPartnersShow/UPDATE_SHOW_DATA';
export const LOAD_SHOW_FAILURE = 'ReferredPartnersShow/LOAD_SHOW_FAILURE';

export const loadReferredPartnersShow = params => ({
  type: LOAD_SHOW,
  params
});

export const setReferredPartnersShow = payload => ({
  type: SET_SHOW_DATA,
  payload
});

export const loadReferredPartnersShowFailure = () => ({
  type: LOAD_SHOW_FAILURE
});

export const showTooltip = activeTooltip => ({
  type: SHOW_TOOLTIP,
  activeTooltip
});

const initialState = {
  loading: true,
  failedLoad: false,
  activeTooltip: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_SHOW_ID:
    case LOAD_SHOW:
      return initialState;
    case SET_SHOW_DATA:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case LOAD_SHOW_FAILURE:
      return {
        ...state,
        failedLoad: true
      };
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.activeTooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: ''
      };
    default:
      return state;
  }
};
